/**
 * Body device class.
 */
function setDeviceClass() {
  const width = window.innerWidth;

  document.body.classList.remove('is-mobile', 'is-tablet', 'is-desktop');

  if (width < 768) {
    document.body.classList.add('is-mobile');
    return;
  }

  if (width < 1024) {
    document.body.classList.add('is-tablet');
    return;
  }

  document.body.classList.add('is-desktop');
}

setDeviceClass();
window.addEventListener('resize', setDeviceClass);


/**
 * Responsive debug.
 */
function responsiveDebug() {
  const isLocal =
    location.hostname.endsWith('.local') ||
    location.hostname.endsWith('.kinsta.cloud') ||
    location.hostname.includes('stg-') ||
    location.hostname === 'localhost' ||
    location.hostname === '127.0.0.1';

  if (!isLocal) {
    return;
  }

  let debug = document.querySelector('.debug-responsive');

  if (!debug) {
    debug = document.createElement('div');
    debug.className = 'debug-responsive';
    debug.innerHTML = '<span></span>';
    document.body.appendChild(debug);
  }

  const updateDebug = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const breakpoint = getBreakpoint(width);
    const span = debug.querySelector('span');

    if (span) {
      span.textContent = `${breakpoint} : ${width}px × ${height}px`;
    }
  };

  updateDebug();
  window.addEventListener('resize', updateDebug);
}

function getBreakpoint(width) {
  if (width < 480) return 'XXS';
  if (width < 768) return 'XS';
  if (width < 1025) return 'SM';
  if (width < 1200) return 'MD';
  if (width < 1500) return 'LG';
  if (width < 1940) return 'XL';
  if (width < 2560) return 'XXL';
  if (width < 3808) return 'XXXL';

  return 'UW';
}

responsiveDebug();


/**
 * Smooth scroll for internal anchors.
 */
document.querySelectorAll('a[href^="#"]').forEach(link => {
  if (link.hasAttribute('data-modal')) {
    return;
  }

  link.addEventListener('click', event => {
    const targetId = link.getAttribute('href');

    if (!targetId || targetId === '#') {
      return;
    }

    const target = document.querySelector(targetId);

    if (!target) {
      return;
    }

    event.preventDefault();

    const offset = 120;
    const top = target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top,
      behavior: 'smooth',
    });
  });
});


/**
 * Sticky header.
 */
const header = document.getElementById('top-header');

if (header) {
  const updateStickyHeader = () => {
    const isSticky = window.scrollY > 0;

    header.classList.toggle('is-sticky', isSticky);
    document.body.classList.toggle('has-sticky-header', isSticky);
  };

  updateStickyHeader();
  window.addEventListener('scroll', updateStickyHeader);
}


/**
 * Add helper class to paragraphs wrapping buttons.
 */
document.querySelectorAll('p').forEach(paragraph => {
  if (paragraph.querySelector('.button')) {
    paragraph.classList.add('has-button');
  }
});